<template>
    <div
        class="w-list-pagination"
        :class="{ 'w-is-loading': loading }"
        v-if="visible"
    >
        <div class="w-list-pagination__inner w-o-grid">
            <div class="w-list-pagination__control w-o-cell">
                <button
                    class="w-list-pagination__button"
                    :class="{ 'w-is-disabled': !canGoto('prev') }"
                    :disabled="!canGoto('prev')"
                    @click="gotoPage('prev')"
                >
                    <icon
                        width="24"
                        height="24"
                        data="@icons/arrow.svg"
                        dir="left"
                    />
                </button>
                <div class="w-list-pagination__label">
                    Seite {{ currentPage }} / {{ totalPages }} ( {{ from }}–{{
                        to
                    }}
                    )
                </div>
                <button
                    class="w-list-pagination__button"
                    :class="{ 'w-is-disabled': !canGoto('next') }"
                    :disabled="!canGoto('next')"
                    @click="gotoPage('next')"
                >
                    <icon
                        width="24"
                        height="24"
                        data="@icons/arrow.svg"
                        dir="right"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ListPagination',
    computed: {
        currentPage() {
            return this.$store.state.pagination.current_page;
        },
        totalPages() {
            return this.$store.state.pagination.total_pages;
        },
        // total() {
        //     return new Intl.NumberFormat('de-DE').format(
        //         this.$store.state.pagination.total
        //     );
        // },
        from() {
            return this.$store.state.pagination.from;
        },
        to() {
            return this.$store.state.pagination.to;
        },
        visible() {
            return this.$store.state.pagination.total > 0;
        },
        loading() {
            return this.$store.state.loading;
        },
    },
    methods: {
        canGoto(target) {
            const num = this.$store.state.pagination.current_page;
            const last = this.$store.state.pagination.total_pages;
            if (target === 'prev' && num > 1) return true;
            if (target === 'next' && num < last) return true;
            return false;
        },
        gotoPage(target) {
            let num = this.$store.state.pagination.current_page;
            if (target === 'prev') {
                num--;
            } else if (target === 'next') {
                num++;
            }
            this.$store.dispatch('gotoPage', {
                num
            });
        },
    },
};
</script>

<style lang="scss">
@import '@/styles/_base.scss';
@import "@/styles/objects/_format.scss";

.w-list-pagination {
    &.w-is-loading {
        opacity: 0.25;
    }
}
.w-list-pagination__inner {
    display: block;
    text-align: center;
}
.w-list-pagination__control {
    width: auto;
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
}
.w-list-pagination__label {
    flex: 0 0 auto;
    padding: 0.5em;
    color: w-get-color("green");
    @include w-o-format("small");
}
.w-list-pagination__button {
    flex: 0 0 auto;
    padding: 0.5em;
    color: w-get-color("bordergray");

    &:focus,
    &:hover {
        color: w-get-color("green");
    }

    &.w-is-disabled,
    &[disabled] {
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
    }
}
</style>
